import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-md";

const OrderStepButtons = props => {
  return (
    <div className="web-order-buttons">
          {props.currentStep > 0 &&
            <Button
              secondary
              raised
              onClick={props.onPrevious}
              children="Previous"
              disabled={props.isLoading}
            />}
          { /* Empty div to keep next button on far right when hiding previous */}
          <div />
          <Button
            primary
            raised
            onClick={props.onNext}
            children={props.nextTitle ?? "Next"}
            disabled={props.isLoading || props.nextIsDisabled}
          />
        </div>
  );
};

OrderStepButtons.propTypes = {
  currentStep: PropTypes.number,  // Current step index used to hide/show buttons
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  isLoading: PropTypes.bool,   // Disables buttons while loading
  nextTitle: PropTypes.string,  // Optional, override next button title
  nextIsDisabled: PropTypes.bool,
};

export default OrderStepButtons;